module.exports = __webpack_public_path__ + "img/hwc_img4.b63906c8.jpg";